module.exports = "/_next/static/media/90a8fcdd16ee36b68ac5e20f525c1f74.svg";